var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilterWhite = function SvgFilterWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.886719 2.96252H15.1131",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.86309 4.16251C4.52583 4.16251 5.06309 3.62525 5.06309 2.96251C5.06309 2.29977 4.52583 1.76251 3.86309 1.76251C3.20034 1.76251 2.66309 2.29977 2.66309 2.96251C2.66309 3.62525 3.20034 4.16251 3.86309 4.16251Z",
    fill: "#1D1D1B",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.886719 8.00012H15.1131",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1629 9.20011C12.8256 9.20011 13.3629 8.66285 13.3629 8.00011C13.3629 7.33737 12.8256 6.80011 12.1629 6.80011C11.5001 6.80011 10.9629 7.33737 10.9629 8.00011C10.9629 8.66285 11.5001 9.20011 12.1629 9.20011Z",
    fill: "#1D1D1B",
    stroke: "white",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.886719 13.0375H15.1131",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0125 14.2375C8.67524 14.2375 9.2125 13.7002 9.2125 13.0375C9.2125 12.3747 8.67524 11.8375 8.0125 11.8375C7.34976 11.8375 6.8125 12.3747 6.8125 13.0375C6.8125 13.7002 7.34976 14.2375 8.0125 14.2375Z",
    fill: "#1D1D1B",
    stroke: "white",
    strokeWidth: 1.5
  })));
};
export default SvgFilterWhite;